let tabsWithContent = (function () {
  let tabs = document.querySelectorAll(".tabs li");
  let tabsContent = document.querySelectorAll(".tab-content");
  let selection = document.querySelector(".tab-selection");
  let tabsContainer = document.querySelector(".tabs");

  if (selection) {
    selection.addEventListener("click", function (e) {
      e.preventDefault();
      this.classList.toggle("active");
      tabsContainer.classList.toggle("open");
    });
    document.addEventListener("click", function (e) {
      let isClickInside = selection.contains(e.target);
      if (!isClickInside) {
        selection.classList.remove("active");
        tabsContainer.classList.remove("open");
      }
    });
  }

  let deactvateAllTabs = function () {
    tabs.forEach(function (tab) {
      tab.classList.remove("is-active");
    });
  };

  let hideTabsContent = function () {
    tabsContent.forEach(function (tabContent) {
      tabContent.classList.remove("is-active");
    });
  };

  let activateTabsContent = function (tab) {
    tabsContent[getIndex(tab)].classList.add("is-active");
  };

  let getIndex = function (el) {
    return [...el.parentElement.children].indexOf(el);
  };

  if (tabs.length > 0) {
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function (e) {
        e.preventDefault();
        deactvateAllTabs();
        hideTabsContent();
        tab.classList.add("is-active");
        activateTabsContent(tab);
        if (selection) {
          selection.innerHTML = tab.getAttribute("data-value");
        }
      });
    });

    tabs[0].click();
  }

  let h = window.location.hash;
  let faqSection = document.querySelector(".faq-section");
  if (h) {
    let tab = document.querySelector('li[data-tabhash="' + h + '"]');
    let tabcontent = document.querySelector(
      'div[data-tabcontenthash="' + h + '"]',
    );
    if (tab && tabcontent) {
      deactvateAllTabs();
      hideTabsContent();
      tab.classList.add("is-active");
      tabcontent.classList.add("is-active");
      faqSection.scrollIntoView();
    }
  }
})();
